import { useTemplatesContext } from "@/pages/templates/context/templatesContext";
import { Paper, Typography } from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import { makeStyles } from "@mui/styles";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
	root: {},
	modalTitle: {
		backgroundColor: "#ced2cc",
		color: "#495057",
		textAlign: "center",
	},
	extensionStyle: {
		border: "1px solid green",
		borderRadius: 8,
		width: "80px",
		height: "80px",
		justifyContent: "center",
		alignItems: "center",
		marginLeft: "auto",
	},
	card: {
		width: "100%",
		height: "auto",
		minHeight: "45px",
		margin: "2px 0",
		backgroundColor: "#f2f2f2",
		borderRadius: 6,
		padding: "8px 10px",
		boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
		position: "relative",
		overflow: "hidden",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
	},
	label: {
		fontSize: 11,
		position: "absolute",
		top: 3,
		left: 10,
		color: "#666",
	},
	value: {
		fontSize: 13,
		position: "absolute",
		bottom: 5,
		left: 10,
		color: "#333",
		overflow: "hidden",
		whiteSpace: "nowrap",
		textOverflow: "ellipsis",
		maxWidth: "92%",
	},
}));

export const DialogHeader = () => {
	const classes = useStyles();

	const {
		state: { rowSelectedInDrawing },
	} = useTemplatesContext();

	return (
		<>
			<Grid2
				container
				style={{ alignItems: "flex-start", padding: "0 20px 10px 10px" }}
			>
				{/* Title Row */}
				<Grid2 size={{ md: 12, xs: 12 }} style={{ marginBottom: "10px" }}>
					<Typography>
						<b>{`${rowSelectedInDrawing?.Title}`}</b>
					</Typography>
				</Grid2>

				{/* Content Row - 3 Columns: BU-00-008 | Information Grid | DWG */}
				<Grid2
					container
					size={{ md: 12, xs: 12 }}
					spacing={2}
					style={{ flexWrap: "nowrap", alignItems: "flex-start" }}
				>
					{/* Column 1: BU-00-008 and OBSOLETE - SMALL */}
					<Grid2
						style={{ position: "relative", flexShrink: 0, width: "140px" }}
					>
						<Paper
							elevation={0}
							className={classes.card}
							style={{
								backgroundColor: "#ccebff",
								margin: 0,
								display: "flex",
								justifyContent: "center",
								alignItems: "center",
							}}
						>
							<Typography
								variant="h6"
								style={{ fontSize: 18, fontWeight: "bold", color: "#333" }}
							>
								{rowSelectedInDrawing?.DocumentName}
							</Typography>
						</Paper>
						{rowSelectedInDrawing?.IsObsolete && (
							<Paper
								elevation={0}
								className={classes.card}
								style={{
									backgroundColor: "#EB9090D9",
									height: "35px",
									borderRadius: 6,
									padding: 6,
									boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.1)",
									overflow: "hidden",
									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									marginTop: "3px",
								}}
							>
								<Typography variant="body2">
									<b>OBSOLETE</b>
								</Typography>
							</Paper>
						)}
					</Grid2>

					{/* Column 2: Information Grid (2 rows x 4 columns) - TAKES MOST SPACE */}
					<Grid2 container spacing={1} size={{ md: 9 }}>
						{/* Row 1 */}
						<Grid2 size={{ md: 3 }}>
							<Paper
								elevation={0}
								className={classes.card}
								style={{ margin: 0 }}
							>
								<Typography variant="subtitle2" className={classes.label}>
									Version
								</Typography>
								<Typography variant="h6" className={classes.value}>
									<b>{rowSelectedInDrawing?.Version}</b>
								</Typography>
							</Paper>
						</Grid2>
						<Grid2 size={{ md: 3 }}>
							{rowSelectedInDrawing?.UploadTimestamp && (
								<Paper
									elevation={0}
									className={classes.card}
									style={{ margin: 0 }}
								>
									<Typography variant="subtitle2" className={classes.label}>
										Uploaded
									</Typography>
									<Typography variant="h6" className={classes.value}>
										<b>
											{moment(
												rowSelectedInDrawing?.UploadTimestamp,
												"YYYY-MM-DDTHH:mm:ss.SSS",
											).format("MM/DD/YYYY HH:mm:ss")}
										</b>
									</Typography>
								</Paper>
							)}
						</Grid2>
						<Grid2 size={{ md: 3 }}>
							<Paper
								elevation={0}
								className={classes.card}
								style={{ margin: 0 }}
							>
								<Typography variant="subtitle2" className={classes.label}>
									Vendor Name
								</Typography>
								<Typography variant="h6" className={classes.value}>
									<b>{rowSelectedInDrawing?.VendorName}</b>
								</Typography>
							</Paper>
						</Grid2>
						<Grid2 size={{ md: 3 }}>
							<Paper
								elevation={0}
								className={classes.card}
								style={{ margin: 0 }}
							>
								<Typography variant="subtitle2" className={classes.label}>
									Vendor Version
								</Typography>
								<Typography variant="h6" className={classes.value}>
									<b>{rowSelectedInDrawing?.VendorVersion}</b>
								</Typography>
							</Paper>
						</Grid2>

						{/* Row 2 */}
						<Grid2 size={{ md: 3 }}>
							<Paper
								elevation={0}
								className={classes.card}
								style={{ margin: 0 }}
							>
								<Typography variant="subtitle2" className={classes.label}>
									User
								</Typography>
								<Typography variant="h6" className={classes.value}>
									<b>{rowSelectedInDrawing?.UserName}</b>
								</Typography>
							</Paper>
						</Grid2>
						<Grid2 size={{ md: 3 }}>
							{rowSelectedInDrawing?.UpdatingUserName &&
							rowSelectedInDrawing?.UpdatingFlag ? (
								<Paper
									elevation={0}
									className={classes.card}
									style={{ backgroundColor: "#d8050f43", margin: 0 }}
								>
									<Typography variant="subtitle2" className={classes.label}>
										Flagged by
									</Typography>
									<Typography variant="h6" className={classes.value}>
										<b>{rowSelectedInDrawing?.UpdatingUserName}</b> on{" "}
										<b>
											{moment(
												rowSelectedInDrawing?.UpdatingTimestamp,
												"YYYY-MM-DDTHH:mm:ss.SSS",
											).format("MM/DD/YYYY HH:mm:ss")}
										</b>
									</Typography>
								</Paper>
							) : (
								<div style={{ minHeight: "50px" }} />
							)}
						</Grid2>
						<Grid2 size={{ md: 3 }}>
							<Paper
								elevation={0}
								className={classes.card}
								style={{ margin: 0 }}
							>
								<Typography variant="subtitle2" className={classes.label}>
									Vendor Document
								</Typography>
								<Typography variant="h6" className={classes.value}>
									<b>{rowSelectedInDrawing?.VendorDocument}</b>
								</Typography>
							</Paper>
						</Grid2>
						<Grid2 size={{ md: 3 }}>
							<Paper
								elevation={0}
								className={classes.card}
								style={{ margin: 0 }}
							>
								<Typography variant="subtitle2" className={classes.label}>
									Vendor Creation
								</Typography>
								<Typography variant="h6" className={classes.value}>
									<b>
										{rowSelectedInDrawing?.VendorDatetime
											? moment(
													rowSelectedInDrawing?.VendorDatetime,
													"MMM D YYYY h:mmA",
												).format("MM/DD/YYYY")
											: ""}
									</b>
								</Typography>
							</Paper>
						</Grid2>
					</Grid2>

					{/* Column 3: DWG */}
					<Grid2 size={{ md: 1 }} style={{ flexShrink: 0 }}>
						<Grid2
							container
							className={classes.extensionStyle}
							style={{
								backgroundColor:
									rowSelectedInDrawing?.Extension === "TIF"
										? "#F8CECC"
										: rowSelectedInDrawing?.Extension === "DWG"
											? "#FFF2CC"
											: rowSelectedInDrawing?.Extension === "CAL"
												? "#D5E8D4"
												: rowSelectedInDrawing?.Extension === "PDF"
													? "#E1D5E7"
													: "#DAE8FC",
								border:
									rowSelectedInDrawing?.Extension === "TIF"
										? "1px solid rgba(255, 0, 0, 0.5)"
										: rowSelectedInDrawing?.Extension === "DWG"
											? "1px solid rgba(255, 255, 0, 0.5)"
											: rowSelectedInDrawing?.Extension === "CAL"
												? "1px solid rgba(0, 128, 0, 0.5)"
												: rowSelectedInDrawing?.Extension === "PDF"
													? "1px solid rgba(128, 0, 128, 0.5)"
													: "1px solid rgba(0, 0, 255, 0.5)",
								height: "95px",
								margin: 0,
								width: "100%",
							}}
						>
							<Grid2 style={{ textAlign: "center" }} size={{ md: 12, xs: 12 }}>
								<b>{rowSelectedInDrawing?.Extension}</b>
							</Grid2>
						</Grid2>
					</Grid2>
				</Grid2>
			</Grid2>
		</>
	);
};
